import ActionsPopover from "@/components/ActionsPopOver/ActionsPopOver";
import ActionsPopOverItem from "@/components/ActionsPopOver/ActionsPopOverItem";
import {
  UniqueRouteLeg,
  useGetOutboundTransportUniqueRoute,
  usePostOutboundTransportRoute,
} from "@/hooks/useTransport";
import { TooltipPlacement } from "antd/es/tooltip";
import { ReactNode, useState } from "react";
import RouteWizard from "./RouteWizard";

export default function OutboundRouteWizard({
  children,
  departureId,
  arrivalId,
  arrivalName,
  byTransportCategory,
  year,
  placement = "bottom",
}: {
  children: ReactNode;
  departureId: number;
  arrivalId?: number;
  arrivalName: string;
  byTransportCategory: boolean;
  year?: number;
  placement?: TooltipPlacement;
}) {
  const saveMutation = usePostOutboundTransportRoute();
  const [isOpen, setIsOpen] = useState(false);
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const [forYear, setForYear] = useState(false);

  const { data, isLoading } = useGetOutboundTransportUniqueRoute({
    departureId,
    arrivalId,
    arrivalName,
    byTransportCategory,
    enabled: isOpen,
    year: forYear ? year : undefined,
  });

  const onSave = (route: UniqueRouteLeg[]) => {
    return saveMutation
      .mutateAsync({
        departure_facility_id: departureId,
        arrival_facility_id: arrivalId,
        arrival_name: arrivalName,
        by_transport_category: byTransportCategory,
        ...(forYear ? { year } : {}),
        route: { route },
      })
      .then(() => {
        setIsOpen(false);
      });
  };

  return (
    <>
      <ActionsPopover
        placement={placement}
        open={isPopoverOpen}
        onOpenChange={setIsPopoverOpen}
        zIndex={6}
        actions={
          <>
            <ActionsPopOverItem
              onClick={() => {
                setIsOpen(!isOpen);
                setForYear(false);
              }}
              black
            >
              Edit all
            </ActionsPopOverItem>
            {year && (
              <ActionsPopOverItem
                onClick={() => {
                  setIsOpen(!isOpen);
                  setForYear(true);
                }}
                black
              >
                Edit {year}
              </ActionsPopOverItem>
            )}
          </>
        }
      >
        {children}
      </ActionsPopover>
      {isOpen && (
        <RouteWizard
          loading={isLoading}
          onClose={() => setIsOpen(false)}
          route={data?.route}
          departure={data?.departure}
          arrival={data?.arrival}
          count={data?.total_count}
          isOpen={isOpen}
          arrivalType={!!arrivalId ? "facility" : "customer"}
          onSave={onSave}
          isSaving={saveMutation.isLoading}
        />
      )}
    </>
  );
}
